'use client';

import { ListItemButton } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import type { ListItemButtonProps } from '@mui/material';

export interface StyledListItemButtonProps extends ListItemButtonProps {
  active?: boolean;
}

const PADDING = 2.5;

export const StyledListItemButton = styled( ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
} )<StyledListItemButtonProps>(({ active, theme }) => ({
  ...theme.typography.body2,
  height: 48,
  // textTransform: 'capitalize',
  paddingLeft: theme.spacing( PADDING ),
  paddingRight: theme.spacing( PADDING ),
  color: theme.palette.text.secondary,
  ...(active && {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity
    ),
  }),
}));
